"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/*
  为了解决 移动端 触摸穿透 没有阻拦的问题 unblocked handle
  <div
    @touchstart="contentTouchStart"
    @touchmove="contentTouchMove"
  ></div>
 */
var _default = {
  data: function data() {
    return {
      touchYStart: 0,
      mScrollTouchYTarget: null,
      mScrollYTarget: null,
      exceedHeight: 0,
      // 超出距离
      touchXStart: 0,
      mScrollTouchXTarget: null,
      mScrollXTarget: null,
      exceedWidth: 0 // 超出距离

    };
  },
  methods: {
    isScrollable: function isScrollable(target, direction) {
      if (direction === void 0) {
        direction = 'x';
      }

      var _ref = direction === 'x' ? {
        scrollKey: 'scrollWidth',
        // 可滚动区域的宽度
        clientKey: 'clientWidth',
        // 可视区域的宽度
        overflowKey: 'overflow-x'
      } : {
        scrollKey: 'scrollHeight',
        // 可滚动区域的高度
        clientKey: 'clientHeight',
        // 可视区域的高度
        overflowKey: 'overflow-y'
      },
          scrollKey = _ref.scrollKey,
          clientKey = _ref.clientKey,
          overflowKey = _ref.overflowKey; // 1. 通过 rem 或者 vw 缩放 可能会导致小数问题 出现 scrollHeight > clientHeight 但是实际是不能滚动 因此增加 校准值
      // 2. 存在 BFC 布局导致 scrollHeight > clientHeight 情况 因此要校验 overflow 样式


      return target[scrollKey] > target[clientKey] + 3 && // el.currentStyle.overflow ie9-
      typeof window !== 'undefined' && ['scroll', 'auto'].includes(window.getComputedStyle(target, null).getPropertyValue(overflowKey));
    },
    getScrollTarget: function getScrollTarget(target, currentTarget, direction) {
      if (direction === void 0) {
        direction = 'x';
      }

      if (!target || target === currentTarget) {
        return target;
      }

      return this.isScrollable(target, direction) ? target : this.getScrollTarget(target.parentNode, currentTarget, direction);
    },
    contentTouchStart: function contentTouchStart(e) {
      this.touchXStart = Math.floor(e.targetTouches[0].clientX);
      this.touchYStart = Math.floor(e.targetTouches[0].clientY);

      if (this.mScrollTouchYTarget !== e.target) {
        this.mScrollYTarget = this.getScrollTarget(e.target, e.currentTarget, 'y');
        this.mScrollTouchYTarget = e.target;
        this.exceedHeight = this.mScrollYTarget.scrollHeight - this.mScrollYTarget.clientHeight;
      }

      if (this.mScrollTouchXTarget !== e.target) {
        this.mScrollXTarget = this.getScrollTarget(e.target, e.currentTarget, 'x');
        this.mScrollTouchXTarget = e.target;
        this.exceedWidth = this.mScrollXTarget.scrollWidth - this.mScrollXTarget.clientWidth;
      }
    },
    contentTouchMove: function contentTouchMove(e) {
      // 检测可滚动区域的滚动事件，如果滑到了顶部或底部，阻止默认事件
      if (this.exceedHeight === 0 && this.exceedWidth === 0) {
        e.preventDefault();
        return false;
      }

      var touchXEnd = Math.floor(e.targetTouches[0].clientX);
      var touchYEnd = Math.floor(e.targetTouches[0].clientY);
      var scrollLeft = this.mScrollXTarget.scrollLeft; // 当前滚动的距离

      var scrollTop = this.mScrollYTarget.scrollTop; // 当前滚动的距离

      switch (this.checkDirection(this.touchXStart, this.touchYStart, touchXEnd, touchYEnd)) {
        case 'X':
          if (this.checkMove(this.touchXStart, touchXEnd, scrollLeft, this.exceedWidth)) {
            e.preventDefault();
            return false;
          }

          break;

        case 'Y':
          if (this.checkMove(this.touchYStart, touchYEnd, scrollTop, this.exceedHeight)) {
            e.preventDefault();
            return false;
          }

          break;
      }

      return true;
    },
    checkMove: function checkMove(touchStart, touchEnd, scroll, exceed) {
      if (exceed === 0) {
        return true;
      }

      if (scroll <= 0 && touchEnd > touchStart) {
        return true;
      } else if (scroll >= exceed && touchEnd < touchStart) {
        return true;
      }

      return false;
    },
    checkDirection: function checkDirection(touchXStart, touchYStart, touchXEnd, touchYEnd) {
      var radian = Math.atan2(touchYEnd - touchYStart, touchXEnd - touchXStart); // 弧度

      var angle = Math.abs(radian * (180 / Math.PI)); // 角度

      return angle >= 30 && angle <= 150 ? 'Y' : 'X';
    }
  }
};
exports["default"] = _default;